<template>
  <div>
    <div class="polygonal-chart__chart-title">
      {{ $t(title) }} (2003)
    </div>
    <div class="d-inline-flex flex-column align-items-center polygonal-chart__border">
      <div
        class="polygonal-chart__chart-container flex-row flex-wrap justify-content-center">
        <b-col
          class="
            polygonal-chart__title
            px-0
            text-center
          "
          cols="12">
          {{ $t('general.triangle') }}
        </b-col>
        <div
          v-for="(chartView, index) in chartViews"
          :key="index"
          class="polygonal-chart__svg-wrapper mb-0"
          :class="chartModifiers"
        >
          <chart-component
            :value="chartView.value"
            :type="chartView.type"
          />
        </div>
        <b-col
          cols="12"
          class="
            text-center
            polygonal-chart__title
            px-0
          "
          >
          {{$t('general.subtitle')}}
        </b-col>
        <b-col class="text-center">
          <subtitle
            class="my-3"
            printView
            v-if="!noSubtitle"
            :value="subtitleValueColors"
          />
        </b-col>
      </div>
    </div>
  </div>
</template>

<script>
import polygonalChartMixin from '@/domain/mixins/installation/engineering/chromatography/polygonalChartMixin';
import ChartComponent from './Chart';
import Subtitle from './Subtitle';

/**
 * Gráfico poligonal.
 */
export default {
  props: {
    title: {
      type: String,
    },
  },
  components: {
    Subtitle,
    ChartComponent,
  },
  mixins: [polygonalChartMixin],
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"
@import "src/styles/defaults/variables"

.polygonal-chart
  &__chart-title
    color: var(--color-primary)
    font-size: 1em
    font-weight: bold
    text-align: left
  &__border
    border: 1px solid $color-gray-intermediary !important
    border-top: none
    box-sizing: border-box
  &__title
    background: var(--color-table-header-bg)
    font-size: 1rem
    font-weight: bold
  &__svg-wrapper
    &_small
      ::v-deep svg
        width: 13.21rem
        margin: .5rem
    &_multiple
      +media-min-lg()
        margin: 1rem
    &_medium
      ::v-deep svg
        width: 24.78rem
        margin: 1rem
    &_multiple
      +media-min-lg()
        margin: 2rem
@media print
  .polygonal-chart
    &__title
      background: var(--color-table-header-bg) !important
    &__chart-container
      padding: 1px
</style>
